import { render, staticRenderFns } from "./base-field.vue?vue&type=template&id=3ea00018"
import script from "./base-field.vue?vue&type=script&lang=js"
export * from "./base-field.vue?vue&type=script&lang=js"
import style0 from "./base-field.vue?vue&type=style&index=0&id=3ea00018&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea00018')) {
      api.createRecord('3ea00018', component.options)
    } else {
      api.reload('3ea00018', component.options)
    }
    module.hot.accept("./base-field.vue?vue&type=template&id=3ea00018", function () {
      api.rerender('3ea00018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/base-field.vue"
export default component.exports